<template>
    <ToDoList></ToDoList>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ToDoList = defineAsyncComponent(() =>
    import("../../components/Facilities/ToDoList.vue")
);

export default {
    name: "To_Do_List", //The name you are in should not equal the name of the component you are importing.
    components: { ToDoList, AuthLayout },
};
</script>
